import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { formContentContainer, loaderOverlay } from "../../Style/loaderOverly";
import { AvForm } from "availity-reactstrap-validation";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, inwardFormData } from "./InwardFile";
import { LoaderCreatePage } from "../Loader/Loader";
import {
  DownloadPDFData,
  getRecords,
  imageURL,
  formatDate,
  formatNumber,
} from "../../services/api.service";
import "../../Style/hypperViewStyle.css";
import UserDetailsModal from "../../components/CommonForBoth/TopbarDropdown/UserProfile/UserDetailModel";
import moment from "moment/moment";
import InwardPDF from "./InwardPDF/InwardPDF";

const InwardView = ({ args }) => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint, referenceOptions } =
    createPageData();
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(inwardFormData());
  const [fetchedData, setFetchedData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isWarehouseModalOpen, setIsWarehouseModalOpen] = useState(false);
  // const [inwardLogData, setInwardLogData] = useState(false);

  const [expandedRows, setExpandedRows] = useState({});
  const [inwardLogData, setInwardLogData] = useState([]);
  const [expandedInwardLogs, setExpandedInwardLogs] = useState({});
  const [expandedMakeItems, setExpandedMakeItems] = useState({});

  useEffect(() => {
    if (id) {
      getEditData(id);
      getInwardLogs(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;

      const updatedInwardItems =
        data?.inward_items &&
        data?.inward_items?.map((item) => ({
          // id: item?.id,
          // item_id: item?.item_id,
          // buy_item_id: item?.buy_item_id,
          // item_code: item.makeItem?.item_code,
          // buy_item_code: item?.buyItem?.item_code,
          // description: item?.buyItem?.description,
          // uom: item.buyItem.uom?.uom_name,
          // qty: item?.invoice_item_qty,
          // remaining_qty: item?.invoice_item_qty,
          // inward_qty: item?.qty,
          // remarks: item?.remarks,
          // is_active: item?.is_active,
          id: item?.id,
          item_id: item?.item_id,
          buy_item_id: item?.buy_item_id,
          item_code: item?.makeItem?.item_code,
          make_item_desc: item?.makeItem?.description,
          make_item_uom: item.makeItem?.uom?.uom_name,
          buy_item_code: item?.buyItem?.item_code,
          description: item?.buyItem?.description,
          uom: item.buyItem?.uom?.uom_name,
          qty: item?.invoice_item_qty,
          remaining_qty: item?.invoice_item_qty,
          shortage_qty: item?.shortage_qty,
          inward_qty: item?.qty,
          provision_qty: item?.provision_qty,
          remarks: item?.remarks,
          is_active: item?.is_active,
          move_to_provision: item?.move_to_provision,
          type: item.is_make_item ? 1 : 2,
        }));
      console.log("updatedInwardItems", updatedInwardItems);

      const inwardDocuments =
        data?.inward_documents &&
        data?.inward_documents?.map((item) => ({
          id: item?.id,
          document: item?.document,
          file: item?.file,
          is_active: item?.is_active,
        }));

      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
          inward_items: updatedInwardItems,
          inward_documents: inwardDocuments,
        },
      }));
    }
  }, [fetchedData]);

  const getInwardLogs = async (Id) => {
    let payload = {
      modelName: "inward_logs",
      whereCondition: {
        inward_id: Id,
      },
    };

    const responseData = await getRecords(payload, "/getRecords");
    if (responseData.code == 1) {
      setInwardLogData(responseData?.data);
    }
  };

  const getEditData = async (Id) => {
    try {
      let payload = {
        id: Id,
        isView: true,
      };

      const responseData = await getRecords(payload, getEndpoint);
      if (responseData?.code == 1) {
        const data = responseData?.data;
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const FloatValue = (value) => {
    return parseFloat(value);
  };

  const handleImageClick = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };

  const filteredItems =
    formData?.inputData?.inward_items?.filter(
      (item) =>
        item?.item_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item?.buy_item_code?.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

  const totalQty =
    filteredItems &&
    filteredItems?.reduce(
      (acc, item) => acc + (parseFloat(item?.remaining_qty) || 0),
      0
    );

  const groupedItems = filteredItems.reduce((acc, item) => {
    if (!acc[item.item_code]) {
      acc[item.item_code] = { makeItem: item, buyItems: [] };
    }

    if (item.buy_item_code) {
      acc[item.item_code].buyItems.push(item);
    }

    return acc;
  }, {});
  let serialNumber = 1;

  const toggleInwardLog = (index) => {
    setExpandedInwardLogs((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleMakeItem = (key) => {
    setExpandedMakeItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Inward Details</h5>
                          <Button
                            style={{ marginLeft: "10px" }}
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                          <Button
                            color="success"
                            className="waves-effect waves-light me-1 back-button ml-2"
                            style={{ borderRadius: "50%" }}
                            onClick={() => DownloadPDFData("InwardDetails.pdf")}
                          >
                            <i class="fas fa-download"></i>
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* Left Section */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Project Name: </strong>
                                {formData?.inputData?.project?.project_name ? (
                                  <span
                                    className="text-primary hover-pointer"
                                    onClick={() =>
                                      navigate(
                                        `/project-view/${
                                          formData?.inputData?.project_id
                                            ? formData?.inputData?.project_id
                                            : formData?.inputData?.project?.id
                                        }`
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {formData?.inputData?.project?.project_name}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Project Code: </strong>
                                {formData?.inputData?.project?.project_code ? (
                                  <span>
                                    {formData?.inputData?.project?.project_code}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>SO No: </strong>
                                {formData?.inputData?.order?.order_no ? (
                                  <span
                                    className="text-primary hover-pointer"
                                    onClick={() =>
                                      navigate(
                                        `/order-view/${
                                          formData?.inputData?.order_id
                                            ? formData?.inputData?.order_id
                                            : formData?.inputData?.order?.id
                                        }`
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {formData?.inputData?.order?.order_no}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>

                              <p>
                                <strong>Invoice No: </strong>
                                {formData?.inputData?.invoice?.invoice_no ? (
                                  <span
                                    className="text-primary hover-pointer"
                                    onClick={() =>
                                      navigate(
                                        `/invoice-view/${
                                          formData?.inputData?.invoice_id
                                            ? formData?.inputData?.invoice_id
                                            : formData?.inputData?.invoice?.id
                                        }`
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {formData?.inputData?.invoice?.invoice_no}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Inward No: </strong>
                                {formData?.inputData?.inward_no ? (
                                  <span>{formData?.inputData?.inward_no}</span>
                                ) : (
                                  "-"
                                )}
                              </p>
                            </Col>

                            {/* Right Section */}
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Warehouse: </strong>
                                <span
                                  className="text-primary cursor-pointer"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setIsWarehouseModalOpen(true)}
                                >
                                  {formData?.inputData?.warehouse
                                    ?.warehouse_name || "-"}
                                </span>
                              </p>

                              {isWarehouseModalOpen && (
                                <UserDetailsModal
                                  onClose={() => setIsWarehouseModalOpen(false)}
                                  id={formData?.inputData?.warehouse?.id}
                                  type="warehouse"
                                />
                              )}
                              <p>
                                <strong>GST No: </strong>
                                {formData?.inputData?.order?.gst_no || "-"}
                              </p>
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <Row className="mt-4">
                        <div className="item-list-container">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h-6-heading">Item Details</h6>
                            <div className="app-search d-flex d-lg-inline mt-0 p-0">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Search by item code..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  style={{
                                    width: "13rem",
                                    padding: "8px 15px",
                                    borderRadius: "8px",
                                    borderColor: "#D2D2D2",
                                    outline: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: "none",
                                    marginRight: "0.5rem",
                                  }}
                                />
                                <span className="ri-search-line"></span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="table mt-2"
                            style={{
                              overflowX: "auto",
                              overflowY: "auto",
                              maxHeight: "500px",
                              width: "100%",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "thin",
                              msOverflowStyle: "none",
                              zIndex: 0,
                            }}
                          >
                            <table className="table table-hover">
                              <thead
                                style={{
                                  backgroundColor: "#8AC1E8",
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#8AC1E8",
                                  borderBottom: "1px solid black",
                                }}
                              >
                                <tr style={{ borderBottom: "1px solid black" }}>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Sr. No
                                  </th>
                                  <th
                                    style={{
                                      width: "15%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Item Code
                                  </th>

                                  <th
                                    style={{
                                      width: "20%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Item Description
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    UOM
                                  </th>

                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Invoice QTY
                                  </th>

                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Inward QTY
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Shortage QTY
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Provision QTY
                                  </th>

                                  <th
                                    colSpan="4"
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "20%",
                                    }}
                                  >
                                    Remark
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {Object.values(groupedItems)?.map(
                                  (group, index) => (
                                    <React.Fragment
                                      key={group.makeItem.unique_id}
                                    >
                                      {group.makeItem.type == 1 && (
                                        <tr
                                          style={{
                                            fontWeight: "bold",
                                            backgroundColor: "#f0f8ff",
                                          }}
                                        >
                                          <td>{serialNumber++}</td>
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "180px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "normal",
                                              }}
                                              title={
                                                group?.makeItem?.item_code ||
                                                "N/A"
                                              }
                                            >
                                              {group?.makeItem?.item_code ||
                                                "N/A"}
                                            </div>
                                          </td>
                                          {/* <td>{"-"}</td> */}
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "180px",
                                            }}
                                          >
                                            {" "}
                                            <div
                                              style={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "normal",
                                              }}
                                              title={
                                                group?.makeItem
                                                  ?.make_item_desc || "N/A"
                                              }
                                            >
                                              {group?.makeItem
                                                ?.make_item_desc || "N/A"}
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "100px",
                                            }}
                                          >
                                            {" "}
                                            {group?.makeItem?.make_item_uom ||
                                              "N/A"}
                                          </td>
                                          <td>{"-"}</td>
                                          <td>{"-"}</td>
                                          <td>{"-"}</td>
                                          <td>{"-"}</td>
                                          <td colSpan="5">{"-"}</td>
                                        </tr>
                                      )}

                                      {group?.buyItems?.map((row, subIndex) => {
                                        if (row.type === 1) {
                                          return (
                                            <tr
                                              key={row.unique_id}
                                              style={{
                                                borderBottom: "1px solid #ccc",
                                              }}
                                            >
                                              <td>{`${serialNumber - 1}.${
                                                subIndex + 1
                                              }`}</td>
                                              {/* <td></td> */}
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.buy_item_code || "N/A"
                                                  }
                                                >
                                                  {row?.buy_item_code || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.description || "N/A"
                                                  }
                                                >
                                                  {row?.description || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {row?.uom || "N/A"}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.remaining_qty
                                                ) || 0}
                                              </td>

                                              <td>
                                                {formatNumber(
                                                  row?.inward_qty
                                                ) || 0}
                                              </td>
                                              <td>
                                                {formatNumber(
                                                  row?.shortage_qty
                                                ) || 0}
                                              </td>
                                              <td>
                                                {formatNumber(
                                                  row?.provision_qty
                                                ) || 0}
                                              </td>
                                              <td>{row?.remarks || "N/A"}</td>
                                            </tr>
                                          );
                                        }
                                        return null;
                                      })}
                                    </React.Fragment>
                                  )
                                )}

                                {filteredItems
                                  ?.filter((row) => row.type == 2)
                                  ?.map((row, index) => (
                                    <tr
                                      key={row.unique_id}
                                      style={{
                                        borderBottom: "1px solid #ccc",
                                      }}
                                    >
                                      <td>{serialNumber++}</td>
                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                          minWidth: "180px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "-webkit-box",
                                            WebkitBoxOrient: "vertical",
                                            WebkitLineClamp: 2,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "normal",
                                          }}
                                          title={row?.item_code || "N/A"}
                                        >
                                          {row?.item_code || "N/A"}
                                        </div>
                                      </td>

                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                          minWidth: "180px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "-webkit-box",
                                            WebkitBoxOrient: "vertical",
                                            WebkitLineClamp: 2,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "normal",
                                          }}
                                          title={row?.description || "N/A"}
                                        >
                                          {row?.description || "N/A"}
                                        </div>
                                      </td>
                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                          minWidth: "100px",
                                        }}
                                      >
                                        {row?.uom || "N/A"}
                                      </td>
                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                          minWidth: "100px",
                                        }}
                                      >
                                        {formatNumber(row?.remaining_qty)}
                                      </td>

                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                          minWidth: "100px",
                                        }}
                                      >
                                        {formatNumber(row?.inward_qty)}
                                      </td>
                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                          minWidth: "100px",
                                        }}
                                      >
                                        {formatNumber(row?.shortage_qty)}
                                      </td>
                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                          minWidth: "110px",
                                        }}
                                      >
                                        {formatNumber(row?.provision_qty) || 0}
                                      </td>

                                      <td
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "2px",
                                          minWidth: "110px",
                                        }}
                                      >
                                        {row?.remarks}
                                      </td>
                                    </tr>
                                  ))}
                                {totalQty >= 1 && (
                                  <tr
                                    style={{
                                      borderTop: "2px solid #cccccc",
                                      backgroundColor: "#d9d9d9",
                                      fontWeight: "bold",
                                      position: "sticky",
                                      bottom: 0,
                                    }}
                                  >
                                    <td></td>
                                    <td>Total</td>
                                    <td colSpan="2"></td>
                                    <td>{formatNumber(totalQty)}</td>
                                    <td colSpan="10"></td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>

                      <Row
                        className="mt-4"
                        style={{
                          display:
                            formData?.inputData?.inward_documents?.length > 0
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="document-details-card p-3">
                          <h6 className="h-6-heading">Document Details</h6>
                          {/* Card Grid Layout for Document Details */}
                          <div className="row">
                            {formData?.inputData?.inward_documents?.length >
                            0 ? (
                              formData?.inputData?.inward_documents?.map(
                                (item, index) => {
                                  return (
                                    item.is_active && (
                                      <div
                                        key={index}
                                        className="col-md-6 col-lg-3"
                                      >
                                        <div
                                          className="card"
                                          style={{
                                            marginBottom: "20px",
                                            borderRadius: "5px",
                                            border: "1px solid #ddd",
                                            overflow: "hidden",
                                            transition:
                                              "transform 0.3s ease, box-shadow 0.3s ease",
                                          }}
                                          onMouseOver={(e) => {
                                            e.currentTarget.style.transform =
                                              "scale(1.05)";
                                            e.currentTarget.style.boxShadow =
                                              "0 4px 10px rgba(0, 0, 0, 0.1)";
                                          }}
                                          onMouseOut={(e) => {
                                            e.currentTarget.style.transform =
                                              "scale(1)";
                                            e.currentTarget.style.boxShadow =
                                              "none";
                                          }}
                                        >
                                          <div
                                            className="card-body"
                                            style={{
                                              padding: "16px",
                                              backgroundColor: "#f9f9f9",
                                            }}
                                          >
                                            <h5
                                              className="card-title"
                                              style={{
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                color: "#343a40",
                                                marginBottom: "12px",
                                              }}
                                            >
                                              {item?.document ||
                                                "Document Name"}
                                            </h5>
                                            <div>
                                              <img
                                                onClick={() =>
                                                  handleImageClick(
                                                    imageURL + item?.file
                                                  )
                                                }
                                                src={imageURL + item?.file}
                                                alt={item?.file}
                                                style={{
                                                  width: "100%",
                                                  height: "200px",
                                                  borderRadius: "5px",
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  );
                                }
                              )
                            ) : (
                              <div className="col-12 text-center">
                                <div
                                  style={{
                                    padding: "20px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    color: "#6c757d",
                                  }}
                                >
                                  No data available.
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </Row>

                      <Row className="mt-4">
                        <div className="item-list-container">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h-6-heading">Inward Logs</h6>
                          </div>
                          <div
                            className="table mt-2"
                            style={{
                              overflowX: "auto",
                              overflowY: "auto",
                              maxHeight: "500px",
                              width: "100%",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "thin",
                              msOverflowStyle: "none",
                              zIndex: 0,
                            }}
                          >
                            <table className="table table-hover">
                              <thead
                                style={{
                                  backgroundColor: "#8AC1E8",
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#8AC1E8",
                                }}
                              >
                                {" "}
                                <tr style={{ borderBottom: "1px solid black" }}>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Sr No
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Inward No
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Created By
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Inward Date
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Status
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>View</th>
                                </tr>
                              </thead>
                              <tbody>
                                {inwardLogData && inwardLogData.length > 0 ? (
                                  inwardLogData.map((log, logIndex) => {
                                    let serialNumber = 1;

                                    return (
                                      <React.Fragment key={logIndex}>
                                        <tr>
                                          <td>{logIndex + 1}</td>
                                          <td>{log.inward_no}</td>
                                          <td>{log.created_by}</td>
                                          <td>{formatDate(log.inward_date)}</td>
                                          <td>{log.status}</td>
                                          <td>
                                            <Link
                                              className="text-primary"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                toggleInwardLog(logIndex);
                                              }}
                                              style={{ cursor: "pointer" }}
                                            >
                                              <i
                                                className={`mdi mdi-${
                                                  expandedInwardLogs[logIndex]
                                                    ? "minus"
                                                    : "plus"
                                                } font-size-22`}
                                              ></i>
                                            </Link>
                                          </td>
                                        </tr>

                                        {expandedInwardLogs[logIndex] && (
                                          <>
                                            <tr
                                              style={{
                                                backgroundColor: "#E5F1FC",
                                                fontWeight: "900",
                                              }}
                                            >
                                              <th></th>
                                              <th>Sr No</th>
                                              <th>Item Code</th>
                                              <th>Item Desc</th>
                                              <th>QTY</th>
                                              <th></th>
                                            </tr>

                                            {log.items.map(
                                              (item, itemIndex) => {
                                                const uniqueItemKey = `${logIndex}-${itemIndex}`;

                                                return (
                                                  <React.Fragment
                                                    key={uniqueItemKey}
                                                  >
                                                    <tr>
                                                      <td></td>
                                                      <td>{serialNumber++}</td>
                                                      <td>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "5px",
                                                            overflow: "hidden",
                                                            textOverflow:
                                                              "ellipsis",
                                                            whiteSpace:
                                                              "nowrap",
                                                            cursor:
                                                              item?.type == 1
                                                                ? "pointer"
                                                                : "default",
                                                          }}
                                                          title={
                                                            item?.make_item_code ||
                                                            "N/A"
                                                          }
                                                        >
                                                          <span>
                                                            {item?.make_item_code ||
                                                              "N/A"}
                                                          </span>

                                                          {item?.type == 1 && (
                                                            <Link
                                                              className="text-primary"
                                                              onClick={(e) => {
                                                                e.stopPropagation();
                                                                toggleMakeItem(
                                                                  uniqueItemKey
                                                                );
                                                              }}
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                            >
                                                              <i
                                                                className={`mdi mdi-chevron-${
                                                                  expandedMakeItems[
                                                                    uniqueItemKey
                                                                  ]
                                                                    ? "up"
                                                                    : "down"
                                                                } font-size-18`}
                                                              ></i>
                                                            </Link>
                                                          )}
                                                        </div>
                                                      </td>
                                                      <td>
                                                        {item.make_item_desc}
                                                      </td>
                                                      <td>
                                                        {item?.type == 1
                                                          ? "-"
                                                          : item.buy_items[0]
                                                              .buy_item_qty}
                                                      </td>
                                                      <td></td>
                                                    </tr>

                                                    {expandedMakeItems[
                                                      uniqueItemKey
                                                    ] &&
                                                      item.buy_items.map(
                                                        (
                                                          buyItem,
                                                          buyItemIndex
                                                        ) => (
                                                          <tr
                                                            key={buyItemIndex}
                                                          >
                                                            <td></td>
                                                            <td
                                                              style={{
                                                                paddingLeft:
                                                                  "30px",
                                                              }}
                                                            >
                                                              {`${
                                                                serialNumber - 1
                                                              }.${
                                                                buyItemIndex + 1
                                                              }`}
                                                            </td>
                                                            <td>
                                                              {
                                                                buyItem.buy_item_code
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                buyItem.buy_item_desc
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                buyItem.buy_item_qty
                                                              }
                                                            </td>
                                                            <td></td>
                                                          </tr>
                                                        )
                                                      )}
                                                  </React.Fragment>
                                                );
                                              }
                                            )}
                                          </>
                                        )}
                                      </React.Fragment>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="6"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div
                            style={{
                              display: "none",
                              position: "absolute",
                              left: "-9999px",
                            }}
                            id="pdfContent"
                          >
                            <InwardPDF data={formData.inputData} />
                          </div>
                        </div>
                      </Row>
                    </AvForm>
                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InwardView;
